// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  guestId: __t.u64(),
  clientTempId: __t.string(),
  recipeId: __t.string(),
  baseCookSecondsMs: __t.i64(),
  appliance: __t.string(),
  seatX: __t.f32(),
  seatZ: __t.f32(),
  seatFloor: __t.u32(),
  seatAtBar: __t.bool(),
};
